import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {Device} from "../api";

export class DeviceService extends RestService<Device> {
    constructor(url: string) {
        if (!url) {
            super(REST_API_END_POINTS.DEVICES)
        } else {
            super(url)
        }
    }
}
